// extracted by mini-css-extract-plugin
export default {"CreateBlog":"create-blog_CreateBlog__+hch1"};